/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { ResultsPartialVftiRegistrantObjectId } from '../models/ResultsPartialVftiRegistrantObjectId';
import { VftiRegistrant } from '../models/VftiRegistrant';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class VftiRegistrantApiResource {

    /**
     * Create a vftiRegistrant
     * 
     * @param body VftiRegistrant data to create
     */
    public createVftiRegistrant(body?: Partial<VftiRegistrant>, axiosConfig?: AxiosRequestConfig): Promise<VftiRegistrant> {
        const reqPath = '/v1/vftiregistrant';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Delete an existing vftiRegistrant
     * 
     * @param id VftiRegistrant id
     */
    public deleteVftiRegistrant(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/vftiregistrant/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'DELETE',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return vftiRegistrants, or query by type or search string
     * 
     * @param type vftiRegistrant type to filter by
     * @param q query search string
     * @param from VftiRegistrant id to start from
     * @param limit Number of results to return
     */
    public findVftiRegistrants(query?: { type?: string, q?: string, from?: string, limit?: number }, axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialVftiRegistrantObjectId> {
        const reqPath = '/v1/vftiregistrant';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular vftiRegistrant by id
     * 
     * @param id VftiRegistrant id
     */
    public getVftiRegistrant(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<VftiRegistrant> {
        const reqPath = '/v1/vftiregistrant/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular vftiRegistrant by slug
     * 
     * @param slug Slug
     */
    public getVftiRegistrantBySlug(slug: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<VftiRegistrant> {
        const reqPath = '/v1/vftiregistrant/slug/{slug}'
                    .replace('{' + 'slug}', String(slug));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Update an existing vftiRegistrant
     * 
     * @param id VftiRegistrant id
     * @param body VftiRegistrant data to update
     */
    public updateVftiRegistrant(id: Partial<string>, body?: Partial<VftiRegistrant>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/vftiregistrant/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'PATCH',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const VftiRegistrantApi = new VftiRegistrantApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/VftiRegistrantApi.ts